import script from "./answerMarking.vue?vue&type=script&setup=true&lang=js"
export * from "./answerMarking.vue?vue&type=script&setup=true&lang=js"

import "./answerMarking.vue?vue&type=style&index=0&id=ab1e07ec&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab1e07ec"]])

export default __exports__